import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IResolveChallengeIssueRequest } from './resolve-challenge-issue-request';
import type { IResolveChallengeIssueResponse } from './resolve-challenge-issue-response';
import { resolveChallengeIssueResponseSchema } from './resolve-challenge-issue-response';

export async function resolveChallengeIssueApi({
  issueId,
  note,
}: IResolveChallengeIssueRequest): Promise<IValidatedResponse<IResolveChallengeIssueResponse>> {
  return postRequest<IResolveChallengeIssueResponse>({
    path: `/sys/challenge-issues/${issueId}/resolve/v1`,
    body: { note },
    schema: resolveChallengeIssueResponseSchema,
  });
}
